import UltimasSolicitacoes from '../components/UltimasSolicitacoes'

let routes = {
    path: '/ultimas_solicitacoes',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/ultimas_solicitacoes',
            name: 'Histórico das solicitações',
            component: UltimasSolicitacoes
        },
    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/ultima_solicitacao.js